import { render } from "./ViewEditDelete.vue?vue&type=template&id=6dbfccc2"
import script from "./ViewEditDelete.vue?vue&type=script&lang=js"
export * from "./ViewEditDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__